<script lang="ts">
  import StatusTag from "@kontextwerk/web-sdk/ui/display/StatusTag.svelte"
  import { mdiAccountOutline } from "@mdi/js"
  let {
    label,
    address = "",
    hint = "",
  }: { label: string; address?: string; hint?: string } = $props()
</script>

<StatusTag
  variant="neutral"
  size="sm"
  {label}
  subLabel={address}
  icon={mdiAccountOutline}
  tooltipContent={hint || undefined}
  disableTitle={true}
/>
